import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far as farP} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
// import { fad } from '@fortawesome/pro-duotone-svg-icons';
//import { fal } from '@fortawesome/pro-light-svg-icons';
//import { fat } from '@fortawesome/pro-thin-svg-icons';

export const ICON_STYLE = "far";

export default function FontAwesomeSetup(){
    library.add(fas);
    library.add(far);
    library.add(fab);
    library.add(farP);
    // library.add(fab);
    // library.add(fad);
    // library.add(fal);
    //library.add(fat);
}

export function parseIconName(newVal) {
    if(!newVal){
        return null;
    }
    if(_.isArray(newVal)){
        if(newVal[0] == "brands"){
            return ["brands", newVal[1]];
        }
        return [ICON_STYLE, newVal[1]];
    }
    let parts = newVal.split(" ");
    if(parts.length == 1){
        if(parts[0].startsWith("brands-")){
            parts[0] = parts[0].substring(7);
            return ["brands", parts[0]];
        }
        if(parts[0] === 'circle') {
            return ['fas', parts[0]];
        }

        return [ICON_STYLE, parts[0]];
    }

    if(parts[1].startsWith("fa-")){
        parts[1] = parts[1].substring(3);
    }
    if(parts[1].startsWith("brands-")){
        parts[1] = parts[1].substring(7);
        return ["brands", parts[1]];
    }

    return [ICON_STYLE, parts[1]];
}


export let FontAwesomeIconWrapper = {...FontAwesomeIcon};

const render = FontAwesomeIconWrapper.render;

FontAwesomeIconWrapper['render'] = function (createElement, context){
    let icon = context.props.icon;
    icon = parseIconName(icon);
    context.props = {...context.props, icon};
    return render(createElement, context);
};


window['i2svg'] = dom.i2svg;
